import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { FullWidthVideo } from "../../ui-components/videos";
import {
	LargeText,
	MediumHeading,
	MediumTitle,
	SmallTitle,
} from "../../ui-components/texts";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";

// images
import imageCover from "../../media/images/portfolio-images/max-boutique/image-cover.jpg";
import image1 from "../../media/images/portfolio-images/max-boutique/image-1.jpg";
import image2 from "../../media/images/portfolio-images/max-boutique/image-2.jpg";

import { useTranslate } from "../../contexts/translate";

const MaxBoutique = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	useEffect(() => {
		setNextPageHref("/projects/trident");
		setNextPageName("Trident");
		document.title = 'Max Boutique - Cutting Edge Digital Creative Studio'
	}, []);

	const { translations } = useTranslate();

	const peoples = [
		{
			fullname: "Simone Ruiz",
			image: require("../../media/team-images/Simone Ruiz.jpg").default,
			role: translations === null ? "" : translations.about.peoples[1].role,
			description:
				translations === null ? "" : translations.about.peoples[1].description,
		},
		{
			fullname: "Andrea Bolloni",
			image: require("../../media/team-images/Andrea Bolloni.jpg").default,
			role: translations === null ? "" : translations.about.peoples[6].role,
			description:
				translations === null ? "" : translations.about.peoples[6].description,
		},
		{
			fullname: "Luca Distefano",
			image: require("../../media/team-images/no-image.png").default,
			role: "Former Video Maker",
			description: ""
		}
	];

	return (
		<div className="project-page project-page-us-lecce">
			<CoverPorfolio
				background="#fff"
				title="Max Boutique"
				text={translations && translations.maxboutique.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Max Boutique"}
				services={["Digital Marketing"]}
				timeframe={"2020"}
				introduction={
					<>
						<LargeText>
							{translations && translations.maxboutique.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.maxboutique.descriptions[1]}
						</LargeText>
						<LargeText>
							{translations && translations.maxboutique.descriptions[2]}
						</LargeText>
					</>
				}
			/>

			<section
				className="theme-dark mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-40">
							<img src={image1} className="w-70" alt="image 1" />
						</Column>
						<Column className="w-60 d-flex">
							<img src={image2} className="mt-25perc" alt="image 2" />
						</Column>
					</div>
				</Container>
			</section>

			<section
				className="theme-dark mid-padding"
				style={{ background: "#020303" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-50">
							<SmallTitle className="white">
								{translations && translations.maxboutique.sections[0].title}
							</SmallTitle>
						</Column>
						<Column className="w-50">
							<LargeText className="white">
								{translations && translations.maxboutique.sections[0].text1}
							</LargeText>
							<LargeText className="white">
								{translations && translations.maxboutique.sections[0].text2}
							</LargeText>
						</Column>
					</div>
				</Container>

				<ContainerBlock className="fluid" style={{ padding: "100px 50px" }}>
					<FullWidthVideo previewImage={require('../../media/images/portfolio-images/max-boutique/preview-video-1.png').default} srcVideo={require('../../media/images/portfolio-images/max-boutique/video-1.mp4').default} />
				</ContainerBlock>
			</section>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-50">
							<SmallTitle>{translations && translations.maxboutique.sections[1].title}</SmallTitle>
						</Column>
						<Column className="w-50">
							<LargeText>
								{translations && translations.maxboutique.sections[1].text}
							</LargeText>
						</Column>
					</div>
				</Container>

				<Container className="pt-50">
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>+ 800%</MediumTitle>
							<MediumHeading>Monthly orders</MediumHeading>
						</Column>
						<Column className="w-40">
							<MediumTitle>+ 1575,76%</MediumTitle>
							<MediumHeading>ROAS</MediumHeading>
						</Column>
					</div>
				</Container>

				<Container>
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>6,60%</MediumTitle>
							<MediumHeading>Conversion Rate Webinar</MediumHeading>
						</Column>
						<Column className="w-40">
							<MediumTitle>2,45%</MediumTitle>
							<MediumHeading>Conversion Rate Running School</MediumHeading>
						</Column>
					</div>
				</Container>
			</section>

			<section
				className="theme-light mid-padding pt-0"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-100">
							<SmallTitle>{translations && translations.maxboutique.sections[2].title}</SmallTitle>
							<LargeText className="mb-4">
								{translations && translations.maxboutique.sections[2].text}
							</LargeText>

							<FullWidthVideo previewImage={require('../../media/images/portfolio-images/max-boutique/preview-video-2.jpg').default} srcVideo={require('../../media/images/portfolio-images/max-boutique/video-2.mp4').default} />
						</Column>

					</div>
				</Container>
			</section>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

MaxBoutique.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default MaxBoutique;
